import { InjectionToken } from '@angular/core';
import { FeatureFlags } from './app-config.token';

export interface AdminAppConfig {
  production: boolean;
  debug: boolean;
  INCLUB_RIBERA_API: string;
  ACCOUNT_MICROSERVICE_API: string;
  SECURITY_MICROSERVICE_API: string;
  CMS_MICROSERVICE_API: string;
  WALLET_MICROSERVICE_API: string;
  OCCUPANCY_MICROSERVICE_API?: string;
  BOOKING_MICROSERVICE_API?: string;
  ROOM_MICROSERVICE_API?: string;
  PAYMENT_MICROSERVICE_API?: string;
  PROMOTERS_MICROSERVICE_API?: string;
  SURVEY_MICROSERVICE_API?: string;
  PROMOTIONS_RIBERA_API?: string;
  EVENT_PRODUCTS_MICROSERVICE_API?: string;
  features?: FeatureFlags;
  gtm?: {
    id: string;
  };
}

export const ADMIN_APP_CONFIG = new InjectionToken<AdminAppConfig>('admin.app.config');
